// extracted by mini-css-extract-plugin
export var card = "_40-0";
export var content = "_40-1";
export var contentLoading = "_40-2";